import { current } from '../helpers'
import { messageBroadcastingMessageBoardsPath, messageBroadcastingMessageBoardMessagesPath } from '../routes'
import SelectAllController from './select_all_controller'

const MESSAGE_BOARDS_FRAME_ID = 'message_broadcasting_message_boards'
const MESSAGES_FRAME_ID = 'message_broadcasting_messages'

const MESSAGE_INPUT_SELECTOR = 'message_broadcasting[message_id]'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'submitButton', 'buttonCount', 'destinationsList',
    'projectStep', 'messageBoardStep', 'messageStep', 'destinationsStep'
  ]

  connect () {
    const mbFrame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (mbFrame) this.initialMessageBoardsHTML = mbFrame.innerHTML
    const msgFrame = document.getElementById(MESSAGES_FRAME_ID)
    if (msgFrame) this.initialMessagesHTML = msgFrame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.clearDestinations()
    this.resetMessages()
    this.setStepState(this.messageStepTarget, 'disabled')
    this.setStepState(this.destinationsStepTarget, 'disabled')
    if (this.projectId) {
      this.loadMessageBoards()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.messageBoardStepTarget, 'active')
    } else {
      this.resetMessageBoards()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.messageBoardStepTarget, 'disabled')
    }
  }

  selectMessageBoard ({ target }) {
    this.loadMessages(target.value)
    this.setStepState(this.messageBoardStepTarget, 'done')
    this.setStepState(this.messageStepTarget, 'active')
    this.setStepState(this.destinationsStepTarget, 'disabled')
  }

  selectMessage () {
    this.setStepState(this.messageStepTarget, 'done')
    this.setStepState(this.destinationsStepTarget, 'active')
    this.submitButtonVisible = true
    this.updateSubmitButtonState()
  }

  toggle (e) {
    super.toggle(e)
    this.updateSubmitButtonState()
  }

  refresh () {
    super.refresh()
    this.updateSubmitButtonState()
    this.reorderDestinations()
  }

  reorderDestinations () {
    if (!this.hasDestinationsListTarget) return
    const items = Array.from(this.destinationsListTarget.querySelectorAll('[data-destination-item]'))

    const firstRects = new Map()
    items.forEach((item) => firstRects.set(item, item.getBoundingClientRect()))

    items.sort((a, b) => {
      const aChecked = a.querySelector('input[type="checkbox"]').checked
      const bChecked = b.querySelector('input[type="checkbox"]').checked
      if (aChecked === bChecked) {
        return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex)
      }
      return aChecked ? -1 : 1
    })
    items.forEach((item) => this.destinationsListTarget.appendChild(item))

    items.forEach((item) => {
      const first = firstRects.get(item)
      const last = item.getBoundingClientRect()
      const dy = first.top - last.top
      if (Math.abs(dy) < 1) return
      item.animate(
        [{ transform: `translateY(${dy}px)` }, { transform: 'translateY(0)' }],
        { duration: 250, easing: 'cubic-bezier(0.2, 0, 0.2, 1)' }
      )
    })
  }

  loadMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = messageBroadcastingMessageBoardsPath(current.account.id, this.projectId)
  }

  loadMessages (messageBoardId) {
    const frame = document.getElementById(MESSAGES_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.listSkeleton())
    frame.src = messageBroadcastingMessageBoardMessagesPath(current.account.id, this.projectId, messageBoardId)
  }

  resetMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame || !this.initialMessageBoardsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialMessageBoardsHTML
  }

  resetMessages () {
    const frame = document.getElementById(MESSAGES_FRAME_ID)
    if (!frame || !this.initialMessagesHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialMessagesHTML
  }

  clearDestinations () {
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
    if (this.hasCheckboxAllTarget) this.checkboxAllTarget.checked = false
  }

  updateSubmitButtonState () {
    const count = this.checked.length
    this.submitButtonDisabled = count === 0 || !this.messageSelected
    this.buttonCountContent = count
  }

  // eslint-disable-next-line accessor-pairs
  set buttonCountContent (count) {
    if (!this.hasButtonCountTarget) return
    this.buttonCountTarget.textContent = count === 1
      ? '1 project'
      : `${count} projects`
  }

  get messageSelected () {
    return !!this.element.querySelector(`input[name="${MESSAGE_INPUT_SELECTOR}"]:checked`)
  }

  get projectId () {
    const hidden = this.element.querySelector('input[type="hidden"][name="message_broadcasting[project_id]"]')
    return hidden?.value || this.projectSelectTarget.value
  }
}
